import { FC } from "react";
import { Routes } from "../components/Routes";
import { IRoutesData } from "../types";

export const RoutesPage: FC<IRoutesData> = ({ data }) => {
  return <Routes data={data} />;  
};